var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownarr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1155 19.6338C14.3499 19.8681 14.6678 19.9998 14.9992 19.9998C15.3307 19.9998 15.6486 19.8681 15.883 19.6338L22.9542 12.5625C23.1819 12.3268 23.3079 12.011 23.3051 11.6833C23.3022 11.3555 23.1708 11.042 22.939 10.8102C22.7073 10.5785 22.3937 10.447 22.066 10.4442C21.7383 10.4413 21.4225 10.5673 21.1867 10.795L14.9992 16.9825L8.81175 10.795C8.576 10.5673 8.26024 10.4413 7.9325 10.4442C7.60475 10.447 7.29124 10.5785 7.05948 10.8102C6.82772 11.042 6.69625 11.3555 6.69341 11.6833C6.69056 12.011 6.81655 12.3268 7.04425 12.5625L14.1155 19.6338Z",
    fill: "#88619A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarr);
export default __webpack_public_path__ + "static/media/downarr.33cc1b45b8356eb4463fb77cdede53bd.svg";
export { ForwardRef as ReactComponent };